import { render, staticRenderFns } from "./YogaProgram.vue?vue&type=template&id=cb75110a&scoped=true&"
import script from "./YogaProgram.vue?vue&type=script&lang=js&"
export * from "./YogaProgram.vue?vue&type=script&lang=js&"
import style0 from "./YogaProgram.vue?vue&type=style&index=0&id=cb75110a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb75110a",
  null
  
)

export default component.exports